import React, { useEffect, useState,useRef } from 'react';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { AxiosInstance } from './components/utils';
import "./css/bootstrap.min.css";
import "./css/animate.min.css";
import "./css/style.css";
import "./css/responsive.css";
import "./css/light-color.css";
import "./css/floatlabel.css";
import "./css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Banner } from './components/sections/banner';
import { Header } from './components/sections/header';
import { AboutEvent } from './components/sections/aboutevent';
import { AdditionalSection } from './components/sections/additionalsection';
import { ScheduleSection } from './components/sections/schedulesection';
import { SpeakersSlider } from './components/sections/speakersslider';
import ScrollToTop from 'react-scroll-to-top';
import Registration from './components/sections/registration';
import { PricingPlan } from './components/sections/pricingplans';
import { SponsorSection } from './components/sections/sponsorsection';
import { PartnerSection } from './components/sections/partnersection';
import { ToastContainer, toast } from 'react-toastify';
import { TicketDetails } from './components/sections/ticketdetails';
import { LocationMap } from './components/sections/locationMap';
import { Contactus } from './components/sections/contactus';
import PosterCreator from './components/sections/postercreator';
import { Footer } from './components/sections/footer';
import { MainHeader } from './components/sections/mainwebsite/mainheader';
import MainWebFooter from './components/sections/mainwebsite/mainwebfooter';
function sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


function EvtHome() {
    const [loading, setLoading] = useState(true);
    const [eventresp, setEventresp] = useState({} as any);
    const [ticketDetails, setTicketDetails] = useState(null as any);
    const ticketRef = useRef(null as any);
    const navigate = useNavigate();
    const { eventcode } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const ticketkey = queryParams.get("ticketkey");
    const errmsg = queryParams.get("msg");
    
    
    useEffect(() => {
        if (eventcode == null) {
            navigate('/pagenotfound');
        }

        const fetchData = async () => {

            setLoading(true);

            const { data: response } = await AxiosInstance.get('/api/getevent?eventcode=' + eventcode);
           
            if (response.result != "Success" || response.data?.length == 0) {
                setLoading(false);
                navigate('/pagenotfound');
            }
            setLoading(false);
            setEventresp(response.data[0]);
            console.log(response.data);
        }

        const fetchTicketDetails = async () => {

            setLoading(true);
            const { data: response } = await AxiosInstance.get('/api/getticket?ticketkey=' + ticketkey);
            if (response.result != "Success") {
                setLoading(false);navigate('/pagenotfound');
                return;
            }
            setLoading(false);
            setTicketDetails(response.ticketdetails);
            console.log(ticketRef);
            if(ticketRef!=null && ticketRef.current !=null)
            {
                console.log(' start scrol ticket');
                ticketRef.current.scrollIntoView({  block: 'center' });
            }
        }


        fetchData();
        if(ticketkey != null && ticketkey != '')
        {
            fetchTicketDetails();
        }
    }, [navigate]);

    if(errmsg)
    {
        let msg = errmsg;
        if(errmsg=='PAYMENT_FAILED')
        {
            msg='Payment Failed. Please retry.';
            toast.error(msg);
        }
        else if(errmsg=='COUPONS_ALREADY_GENERATED')
        {
            msg='Coupons already sent to mail.';
            toast.error(msg);
        }
        else if(errmsg=='GROUP_PAY_SUCCESS')
        {
            msg='Payment Successful. Please check mail for further details.';
            toast(msg);
        }
    }
    if (loading) {
        return (<div id="preloader">
            <div id="status">
                <div className="spinner"></div>
            </div>
        </div>);
    }
    else {
        return (
            <>
{eventresp && <div className="antialiased light-vz circle-v ">
    
                <Header eventInfo={eventresp} />
                {ticketDetails && <><div style={{paddingTop: '20px'}}><TicketDetails ticketDetails={ticketDetails} ticketRef={ticketRef} /></div></>  }

                {!ticketDetails && (
                    <>
                    
                     <Banner eventInfo={eventresp} />
                        <AboutEvent  eventInfo={eventresp} />
                        { eventresp.eventcode=="acsc2025" && <>  <section id="ctf" data-scroll-index="11" className="faqs-sec sec-padding">
                            <div className="container">
                                <div className="sec-title">
                                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                                    <h3 className="wow fadeInRight" data-wow-duration="500ms">CTF <small> </small></h3>
                                   
                                </div> 
                                <div className="faqs-sec-details wow fadeInUp" data-wow-duration="300ms">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <ul className="nav nav-tabs wow fadeInUp" data-wow-delay=".2s" id="myTab6" role="tablist">
                                                <li className="nav-item">
                                                    <a className="nav-link active" id="ques-tab1" data-toggle="tab" href="#ques1" role="tab" aria-controls="ques1" aria-selected="true"> B5CTF: Corporate </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="ques-tab2" data-toggle="tab" href="#ques2" role="tab" aria-controls="ques2" aria-selected="false"> B5CTF: Students </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="ques-tab3" data-toggle="tab" href="#ques3" role="tab" aria-controls="ques3" aria-selected="false"> W2CTF </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="ques-tab4" data-toggle="tab" href="#ques4" role="tab" aria-controls="ques4" aria-selected="false"> LIVE HACKING </a>
                                                </li>
                                            </ul> {/* <!--tabs-list end--> */}
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="tab-content" id="myTabContent6">
                                                <div className="tab-pane fade show active" id="ques1" role="tabpanel" aria-labelledby="ques-tab1">
                                                    <div className="ques-details">
                                                    <h1>🛡️ B5CTF: Corporate</h1>
  <p>
    B5CTF: Corporate is a Capture The Flag competition designed exclusively for corporate cybersecurity professionals — your chance to test your skills, compete with peers, and showcase your hacking expertise on a global platform!
  </p>

  <p>
    👨‍💼👩‍💼 Whether you're a seasoned infosec expert or a rising cybersecurity enthusiast, this event will challenge you with real-world, hands-on scenarios across a range of domains.
  </p>

  <h2>🗓️ Event Schedule (IST)</h2><br/>

    <li>📅 <strong>June 28, 2025</strong><br/>
      🕒 15:00 IST – <strong>CTF Begins 🚀</strong>
    </li><br/>
    <li>📅 <strong>June 29, 2025</strong><br/>
      🕛 12:00 IST – <strong>Scoreboard Hidden</strong><br/>
      🕒 15:00 IST – <strong>CTF Ends 🏁</strong>
    </li><br/><br/>


  <h2>🏆 Why Should You Participate?</h2><br/>
 
    <li>✅ Compete with top cybersecurity talent</li>
    <li>✅ Sharpen your practical infosec skills</li>
    <li>✅ Gain visibility and recognition in the community</li>
    <li>✅ Win exciting prizes while learning and gaining hands-on experience</li>
    <li>✅ Walk away with bragging rights from one of India's premier cybersecurity CTFs!</li>
  

  <p>📢 <strong>Registration is now open!</strong></p>
  <p>🔗 <a href="https://app.metactf.com/join/bsides-bangalore25-ctf1" target="_blank">Join here</a></p>
  <br/><br/>
  <h2>🎁 Prizes</h2>
  <br/>
    <li>1. <strong>First Place:</strong> 15k INR cash prize, Trophy & Winner Certificate</li>
    <li>2. <strong>Second Place:</strong> 7k INR cash prize, Trophy & Winner Certificate</li>
    <li>3. <strong>Top 3 Runner Ups:</strong> ₹1500 gift voucher per person, Certificate</li>
    <li>4. <strong>Top 3 Teams:</strong> 3 months access to MetaCTF's new OnDemand Labs platform</li>
    <li>5. <strong>All Participants:</strong> Participation certificates</li>
    <li>6. <strong>Note:</strong> Winners must be physically present at the BSides Bangalore & W3-CS Annual Conference 2025 to collect their Award Trophy. ID will be required for verification.</li>
 

                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                                <div className="tab-pane fade" id="ques2" role="tabpanel" aria-labelledby="ques-tab2">
                                                    <div className="ques-details">
                                                        
  <h1>🎮 BSides Bangalore Binary Blitz Battle (B5)</h1>
  <p>
    Hosted by MetaCTF — as part of the BSides Bangalore & W3-CS Annual Cybersecurity Conference 2025!
  </p>

  <h2>🛡️ B5CTF: Students</h2>
  <p>
    A Capture The Flag competition created exclusively for students and emerging cybersecurity enthusiasts — your opportunity to dive into real-world challenges, learn hands-on skills, and compete with the brightest student minds from across the country!
  </p>

  <p>
    👨‍🎓👩‍🎓 Whether you're studying computer science, cybersecurity, or just passionate about ethical hacking, this CTF will help sharpen your skills and grow your network in the infosec community.
  </p>

  <h2>🗓️ Event Schedule (IST)</h2>
  <li>📅 June 28, 2025<br/>
      🕒 15:00 IST – CTF Begins 🚀</li><br/>
  <li>📅 June 29, 2025<br/>
      🕒 15:00 IST – CTF Ends 🏁</li><br/>

  <h2>🏆 Why Should You Participate?</h2>
  <li>✅ Learn by doing — hands-on experience with real-world scenarios</li>
  <li>✅ Collaborate and compete with other student teams</li>
  <li>✅ Gain exposure to key cybersecurity domains</li>
  <li>✅ Win exciting prizes and certificates</li>
  <li>✅ Boost your resume with a standout achievement</li>
  <li>✅ Get noticed by industry experts and recruiters!</li><br/>

  <p>📢 <strong>Registration is now open!</strong><br/>
  🔗 <a href="https://app.metactf.com/join/bsides-bangalore25-ctf2" target="_blank">Join here</a></p><br/>

  <h2>🎁 Prizes</h2>
  <li>1. First Place: 15k INR cash prize, Trophy & Winner Certificate</li>
  <li>2. Second Place: 7k INR cash prize, Trophy & Winner Certificate</li>
  <li>3. Top 3 Runner Ups: ₹1500 gift voucher per person, Certificate</li>
  <li>4. Top 3 Teams: 3 months access to MetaCTF's new OnDemand Labs platform</li>
  <li>5. All Participants: Participation certificates</li>
  <li>6. Note: Winners must be physically present at the BSides Bangalore & W3-CS Annual Conference 2025 to collect their Award Trophy. An Identification card will be required for verification.</li>

                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                                <div className="tab-pane fade" id="ques3" role="tabpanel" aria-labelledby="ques-tab3">
                                                    <div className="ques-details">
                                                       
  <h1>💪💻🌍 Wonder Women CTF (W2CTF)</h1>
  <p>
    We're thrilled to launch Wonder Women CTF (W2CTF) as part of BSides Bangalore & the W3-CS Annual Conference 2025!<br/>
    In collaboration with @CyberTalents, W3-CS (World Wide Women in Cyber Security) brings you a 6-hour online CTF competition, exclusively for women.
  </p>

  <h2>📝 Description</h2>
  <p>
    World Wide Women in Cyber Security (W3-CS) is thrilled to join forces with the CyberTalents platform to present the Wonder Women Capture The Flag (W2CTF) during BSides Bangalore & W3-CS Annual Conference 2025 — a dynamic and empowering competition designed to inspire and engage women in the ever-evolving field of cybersecurity.
  </p>
  <p>
    W2CTF is a six-hour, online Capture The Flag (CTF) competition tailored exclusively for women, aiming to ignite curiosity, build skills, and foster greater representation of women in the cybersecurity domain. The CTF has a jeopardy-style format, featuring a diverse range of technical challenges across categories such as Reverse Engineering, Web Security, Digital Forensics, Network Security, and more.
  </p>
  <p>
    No matter your experience level — whether you're just starting out or a seasoned pro — W2CTF has something for everyone! With challenges ranging from beginner-friendly puzzles to advanced exploits, participants will have the opportunity to test their knowledge, sharpen their skills, and connect with a global community of like-minded women in tech.
  </p>

  <h2>🎯 Why Participate?</h2>
  <li>✅ Learn new skills</li>
  <li>✅ Showcase your talent</li>
  <li>✅ Connect with an incredible global community of women in cybersecurity</li>
  <li>🎯 Let's break barriers and be part of an exciting journey that celebrates women in cybersecurity and pushes the boundaries of what's possible!</li><br/>

  <h2>📅 Mark Your Calendars</h2>
  <li>Date: 22nd June 2025</li>
  <li>Time: 10:00 AM to 4:00 PM IST</li>
  <li>Format: Virtual/Online Competition</li>
  <li>Participation: Individual</li><br/>

  <h2>📝 Registration Steps</h2>
  <li>1. Create an account on CyberTalents: <a href="https://cybertalents.com/register/member" target="_blank">https://cybertalents.com/register/member</a></li>
  <li>2. Go to the CTF webpage for details: <a href="https://cybertalents.com/competitions/wonder-women-capture-the-flag-w2ctf" target="_blank">Wonder Women CTF Page</a></li>
  <li>3. Access to challenges and real-time scoreboard updates will be available once the CTF kicks off.</li><br/>

  <h2>🎁 Prizes</h2>
  <li>🥇 First Place: 15k INR cash prize, Trophy and Winner Certificate</li>
  <li>🥈 Second Place: 7k INR cash prize, Trophy and Winner Certificate</li>
  <li>Top 3 Runner Ups: ₹1500 gift voucher per person, Certificate</li>
  <li>All Participants: Participation certificates</li>
  <li>Note: Winners must be physically present at the BSides Bangalore & W3-CS Annual Conference 2025 to collect their Award Trophy. An Identification card will be required for verification.</li>

                                                    </div> {/* <!--ques-details end--> */}
                                                </div>


                                                <div className="tab-pane fade" id="ques4" role="tabpanel" aria-labelledby="ques-tab4">
                                                    <div className="ques-details">
                                                    <h1>𝗟𝗶𝘃𝗲 𝗛𝗮𝗰𝗸𝗶𝗻𝗴 | 💰 Big Bounties!</h1>
  <p>
    Get ready for the ultimate bug bounty battle!<br/>
    BSides Bangalore & Groww presents an electrifying Live Hacking Event like never before. 💣<br/>
    Up to $7500 per valid bug.
  </p>

  <h2>💸 Bounties (1.5X Special Payout!)</h2>
  <li>🟢 Low: $150 – $400</li>
  <li>🟡 Medium: $400 – $750</li>
  <li>🟠 High: $1000 – $2000</li>
  <li>🔴 Critical: $2500 – $7500</li>
  <li>💥 Total bounty pool? Up to $7,500 per bug!</li><br/>

  <h2>🏆 Awards & Recognition</h2>
  <li>Top 5 hackers + 1 MVP will be crowned live on the BSides stage (11th July 2025)</li>
  <li>🎫 Free non-transferable passes to BSides Bangalore 2025 for the winners</li><br/>

  <h2>📌 Event Details</h2>
  <li>🚀 Limited Seats – Curated Entry Only</li>
  <li>🗓️ Form closes: 3rd July 2025</li>
  <li>🍽️ Lunch & high tea covered</li>
  <li>🚫 Travel/stay not included</li><br/>

  <p>
    Let's hack out loud. Let's hack proud.
  </p>
                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                            </div> {/* <!--tab-content end--> */}
                                        </div>
                                    </div>
                                </div> {/* <!-- faqs-sec-details end--> */}
                            </div>
                        </section> </>}
                        <AdditionalSection />
                        <SponsorSection eventInfo={eventresp} />
                        <PartnerSection eventInfo={eventresp} />


                        <section className="faqs-sec sec-padding">
                            <div className="container">
                                <div className="sec-title">
                                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Event FAQS <small>/ find your answers </small></h3>
                                    {/*<a href="#" title=""><i className="fa fa-pencil"></i>open a tıcket</a>*/}
                                </div> {/* <!--sec-title end--> */}
                                <div className="faqs-sec-details wow fadeInUp" data-wow-duration="300ms">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <ul className="nav nav-tabs wow fadeInUp" data-wow-delay=".2s" id="myTab6" role="tablist">
                                                <li className="nav-item">
                                                    <a className="nav-link active" id="ques-tab1" data-toggle="tab" href="#ques1" role="tab" aria-controls="ques1" aria-selected="true"> What is Security BSides and BSides Bangalore? </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="ques-tab2" data-toggle="tab" href="#ques2" role="tab" aria-controls="ques2" aria-selected="false"> Is the conference pass transferable? </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="ques-tab3" data-toggle="tab" href="#ques3" role="tab" aria-controls="ques3" aria-selected="false"> Can I get a refund if I am not able to attend? </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="ques-tab4" data-toggle="tab" href="#ques4" role="tab" aria-controls="ques4" aria-selected="false"> What is the privacy policy of BSides Bangalore? </a>
                                                </li>
                                            </ul> {/* <!--tabs-list end--> */}
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="tab-content" id="myTabContent6">
                                                <div className="tab-pane fade show active" id="ques1" role="tabpanel" aria-labelledby="ques-tab1">
                                                    <div className="ques-details">
                                                        <p>Security BSides is a community-led framework for establishing events for and by information security community members across the globe. This was launched in the United States in 2009. As of now, there have been 810 BSides events around the world, hosted in 210 cities spanning 60 countries and growing everyday. To find out more about the Security BSides movement visit the <a href="https://bsides.org/w/page/12194156/FrontPage" target="_blank" >Security BSides wiki</a> today.</p>
                                                        <p>BSides Bangalore is a non-profit entity approved by BSides. It is driven and supported by cybersecurity community members across the globe. BSides Bangalore presents technical security talks, technical hands-on workshops, CTF, Pannel Discussions, CxO junction and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends.</p>
                                                        {/*<ul>
                                                            <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                            <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                            <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                            <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                            <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                            <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                        </ul>*/}
                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                                <div className="tab-pane fade" id="ques2" role="tabpanel" aria-labelledby="ques-tab2">
                                                    <div className="ques-details">
                                                        <p>Entry pass is not transferable. In case of questions, you can write to event organizers through "Contact Us" section in this website. </p>
                                                      
                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                                <div className="tab-pane fade" id="ques3" role="tabpanel" aria-labelledby="ques-tab3">
                                                    <div className="ques-details">
                                                        <p>Registration once done cannot be cancelled. In case of questions, you can write to event organizers through "Contact Us" section in this website.</p>
                                                       
                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                                <div className="tab-pane fade" id="ques4" role="tabpanel" aria-labelledby="ques-tab4">
                                                    <div className="ques-details">
                                                        <p>Privacy policy and other terms and conditions can be found at <a href="https://bsidesbangalore.in/privacypolicy?policy_type=Terms" target="_blank">https://bsidesbangalore.in/privacypolicy?policy_type=Terms</a></p>
                                                    </div> {/* <!--ques-details end--> */}
                                                </div>
                                            </div> {/* <!--tab-content end--> */}
                                        </div>
                                    </div>
                                </div> {/* <!-- faqs-sec-details end--> */}
                            </div>
                        </section> {/* <!--faqs-sec end--> */}

                        <section className="doc-sec sec-padding">
                            <div className="container">
                                <div className="sec-title">
                                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-ticket fa-stack-1x"></i></span></span>
                                    <h3 className="wow fadeInRight" data-wow-duration="500ms">About BSides Bangalore <small>/ How to become a member</small></h3>
                                </div> {/* <!--sec-title end--> */}
                                <div className="doc-sec-details">
                                    <p>Security BSides is a community-led framework for establishing events for and by information security community members across the globe. BSides Bangalore is a non-profit entity approved by BSides. It is driven and supported by cybersecurity community members across the globe. BSides Bangalore presents technical security talks, technical hands-on workshops, CTF, Pannel Discussions, CxO junction and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends. More details can be found at <a href="https://bsidesbangalore.in" target="_blank">https://bsidesbangalore.in</a></p>
                                    <p>You can become a member by visiting <a target="_blank" href="https://bsidesbangalore.in/registermember" >https://bsidesbangalore.in/registermember </a></p>
                                </div> {/* <!-- about-sec-details end--> */}
                            </div>
                        </section> {/* <!--about-sec end--> */}

                       

                        

                       <LocationMap eventInfo={eventresp} />
                        <Contactus />
                        <section className="sec-padding testimonial-sect background-color-white">
                            <div className="container">
                                <div className="sec-title">
                                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-comments-o fa-stack-1x"></i></span></span>
                                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Testimonials <small> / What People Say About Us</small></h3>
                                </div> {/* <!--sec-title end--> */}
                                <div className="testimonial-sec font-color-black">
                                    <div className="comment-slide">
                                        <div className="comment-para wow flipInY" data-wow-duration="300ms">
                                            <p>I recently had the incredible opportunity to attend a highly anticipated conference in the field of cybersecurity. It was an enlightening and enriching experience that broadened my knowledge and provided me with valuable insights into the ever-evolving world of cybersecurity. At the conference, I had the privilege of attending a wide range of informative sessions and workshops, where renowned experts shared their expertise on the latest trends, strategies, and technologies in the field. From exploring emerging threats to understanding advanced defensive techniques, every session was packed with valuable information that I can directly apply to my work. But that's not all! The conference surprised me with an exciting hands-on session on secret lock picking. Led by skilled professionals, the session offered a unique opportunity to explore the fascinating world of physical security and understand the vulnerabilities that lie beyond digital defenses. It was a thrilling experience that further broadened my perspective on cybersecurity. I look forward to sharing my learnings with my colleagues at Jio and collaborating with them to strengthen our organization's security posture. Together, we can mitigate risks, protect sensitive information, and ensure a secure digital environment. Huge thanks to the organisers, volunteers and presenters of #bsidesbangalore and Sponsors for awesome swags.</p>
                                            <div className="commenter-name">
                                                <span>by  Participant </span>
            </div>
                                        </div>
                                       {/* <div className="cmntr-img wow flipInY" data-wow-duration="300ms">
                                            <div className="hex-deg">
                                                <div className="hex-deg">
                                                    <div className="hex-deg">
                                                        <div className="hex-inner">
                                                            <img src="/images/resources/t-img1.jpg" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
        </div>*/}
                                    </div> {/* <!--comment-slide end--> */}
                                    <div className="comment-slide">
                                        <div className="comment-para wow flipInY" data-wow-duration="300ms">
                                            <p>It was an incredible experience being part of the first-ever edition of BSides Bangalore. I was honored to be part of the Award Jury Panel in partnership with eminent industry leaders. Members of the Organizing Committee and all the volunteers have worked tirelessly over the past several weeks for making this 4 Conference a great success, which was evident from the overwhelming attendance, crazy energy, and community vibe. I am humbled by all your hard work and passion for growing the community. It was a difficult job to choose the winners from the list of all the great nominations across various categories. I deeply appreciate the founders for keeping the entire process absolutely transparent and unbiased with the sole purpose of recognizing and encouraging the contributions towards the larger security community. Congratulations to all the deserving winners and best wishes to all nominees to continue supporting the wider security community and amplify the mutual growth. Members of the Organizing Committee and all the volunteers have worked tirelessly over the past several weeks for making this Conference a great success, which was evident from the overwhelming attendance, crazy energy, and community vibe. I am humbled by all your hard work and greatly appreciate all your efforts.</p>
                                            <div className="commenter-name">
                                                <span>by  Participant </span>
            </div>
                                        </div>
                                       {/* <div className="cmntr-img wow flipInY" data-wow-duration="300ms">
                                            <div className="hex-deg">
                                                <div className="hex-deg">
                                                    <div className="hex-deg">
                                                        <div className="hex-inner">
                                                            <img src="/images/resources/t-img2.jpg" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
        </div>*/}
                                    </div> {/* <!--comment-slide end--> */}
                                    <div className="comment-slide">
                                        <div className="comment-para wow flipInY" data-wow-duration="300ms">
                                            <p>It was truly an enriching experience attending BSides Bangalore Cybersecurity Conference. The conference was power-packed with various Keynote Addresses, Interactive Cybersecurity Technical Sessions, Engaging Panel Discussions, Hands-on Workshops, Lockpicking & Hardware Villages, ToolsForge, CTFs, CXO Round-table, Awards Ceremony, Sponsor Booths, Goodies & Swags, etc It was an amazing opportunity to witness some of the sharpest & most innovative minds which included several Information Security executives, leaders, experts, evangelists, enthusiasts, researchers, professionals & students. A huge thank you to the entire Team BSides Bangalore - all the organizers & volunteers for their tremendous hardwork & enormous efforts to make this a grand success. All in all, an event that will be cherished for long!</p>
                                            <div className="commenter-name">
                                                <span>by  Participant </span>
            </div>
                                        </div>
                                        {/*<div className="cmntr-img wow flipInY" data-wow-duration="300ms">
                                            <div className="hex-deg">
                                                <div className="hex-deg">
                                                    <div className="hex-deg">
                                                        <div className="hex-inner">
                                                            <img src="/images/resources/t-img3.jpg" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
        </div>*/}
                                    </div> {/* <!--comment-slide end--> */}
                                </div> {/* <!--testimonial-sec end--> */}
                            </div>
                        </section> {/* <!--sec-padding end--> */}
                    </>
                )}
                { eventresp.eventcode=="acsc2025" && <>  <section id="ctf" data-scroll-index="11" className="faqs-sec sec-padding">
                    <div className="container">
                        <div className="sec-title">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">CTF <small> </small></h3>
                           
                        </div> 
                        <div className="faqs-sec-details wow fadeInUp" data-wow-duration="300ms">
                            <div className="row">
                                <div className="col-lg-6">
                                    <ul className="nav nav-tabs wow fadeInUp" data-wow-delay=".2s" id="myTab6" role="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link active" id="ques-tab1" data-toggle="tab" href="#ques1" role="tab" aria-controls="ques1" aria-selected="true"> B5CTF: Corporate </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="ques-tab2" data-toggle="tab" href="#ques2" role="tab" aria-controls="ques2" aria-selected="false"> B5CTF: Students </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="ques-tab3" data-toggle="tab" href="#ques3" role="tab" aria-controls="ques3" aria-selected="false"> W2CTF </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="ques-tab4" data-toggle="tab" href="#ques4" role="tab" aria-controls="ques4" aria-selected="false"> LIVE HACKING </a>
                                        </li>
                                    </ul> {/* <!--tabs-list end--> */}
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-content" id="myTabContent6">
                                        <div className="tab-pane fade show active" id="ques1" role="tabpanel" aria-labelledby="ques-tab1">
                                            <div className="ques-details">
                                            <h1>🛡️ B5CTF: Corporate</h1>
  <p>
    B5CTF: Corporate is a Capture The Flag competition designed exclusively for corporate cybersecurity professionals — your chance to test your skills, compete with peers, and showcase your hacking expertise on a global platform!
  </p>

  <p>
    👨‍💼👩‍💼 Whether you're a seasoned infosec expert or a rising cybersecurity enthusiast, this event will challenge you with real-world, hands-on scenarios across a range of domains.
  </p>

  <h2>🗓️ Event Schedule (IST)</h2><br/>

    <li>📅 <strong>June 28, 2025</strong><br/>
      🕒 15:00 IST – <strong>CTF Begins 🚀</strong>
    </li><br/>
    <li>📅 <strong>June 29, 2025</strong><br/>
      🕛 12:00 IST – <strong>Scoreboard Hidden</strong><br/>
      🕒 15:00 IST – <strong>CTF Ends 🏁</strong>
    </li><br/><br/>


  <h2>🏆 Why Should You Participate?</h2><br/>
 
    <li>✅ Compete with top cybersecurity talent</li>
    <li>✅ Sharpen your practical infosec skills</li>
    <li>✅ Gain visibility and recognition in the community</li>
    <li>✅ Win exciting prizes while learning and gaining hands-on experience</li>
    <li>✅ Walk away with bragging rights from one of India’s premier cybersecurity CTFs!</li>
  

  <p>📢 <strong>Registration is now open!</strong></p>
  <p>🔗 <a href="https://app.metactf.com/join/bsides-bangalore25-ctf1" target="_blank">Join here</a></p>
  <br/><br/>
  <h2>🎁 Prizes</h2>
  <br/>
    <li>1. <strong>First Place:</strong> 15k INR cash prize, Trophy & Winner Certificate</li>
    <li>2. <strong>Second Place:</strong> 7k INR cash prize, Trophy & Winner Certificate</li>
    <li>3. <strong>Top 3 Runner Ups:</strong> ₹1500 gift voucher per person, Certificate</li>
    <li>4. <strong>Top 3 Teams:</strong> 3 months access to MetaCTF’s new OnDemand Labs platform</li>
    <li>5. <strong>All Participants:</strong> Participation certificates</li>
    <li>6. <strong>Note:</strong> Winners must be physically present at the BSides Bangalore & W3-CS Annual Conference 2025 to collect their Award Trophy. ID will be required for verification.</li>
 

                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                        <div className="tab-pane fade" id="ques2" role="tabpanel" aria-labelledby="ques-tab2">
                                            <div className="ques-details">
                                                
  <h1>🎮 BSides Bangalore Binary Blitz Battle (B5)</h1>
  <p>
    Hosted by MetaCTF — as part of the BSides Bangalore & W3-CS Annual Cybersecurity Conference 2025!
  </p>

  <h2>🛡️ B5CTF: Students</h2>
  <p>
    A Capture The Flag competition created exclusively for students and emerging cybersecurity enthusiasts — your opportunity to dive into real-world challenges, learn hands-on skills, and compete with the brightest student minds from across the country!
  </p>

  <p>
    👨‍🎓👩‍🎓 Whether you're studying computer science, cybersecurity, or just passionate about ethical hacking, this CTF will help sharpen your skills and grow your network in the infosec community.
  </p>

  <h2>🗓️ Event Schedule (IST)</h2>
  <li>📅 June 28, 2025<br/>
      🕒 15:00 IST – CTF Begins 🚀</li><br/>
  <li>📅 June 29, 2025<br/>
      🕒 15:00 IST – CTF Ends 🏁</li><br/>

  <h2>🏆 Why Should You Participate?</h2>
  <li>✅ Learn by doing — hands-on experience with real-world scenarios</li>
  <li>✅ Collaborate and compete with other student teams</li>
  <li>✅ Gain exposure to key cybersecurity domains</li>
  <li>✅ Win exciting prizes and certificates</li>
  <li>✅ Boost your resume with a standout achievement</li>
  <li>✅ Get noticed by industry experts and recruiters!</li><br/>

  <p>📢 <strong>Registration is now open!</strong><br/>
  🔗 <a href="https://app.metactf.com/join/bsides-bangalore25-ctf2" target="_blank">Join here</a></p><br/>

  <h2>🎁 Prizes</h2>
  <li>1. First Place: 15k INR cash prize, Trophy & Winner Certificate</li>
  <li>2. Second Place: 7k INR cash prize, Trophy & Winner Certificate</li>
  <li>3. Top 3 Runner Ups: ₹1500 gift voucher per person, Certificate</li>
  <li>4. Top 3 Teams: 3 months access to MetaCTF’s new OnDemand Labs platform</li>
  <li>5. All Participants: Participation certificates</li>
  <li>6. Note: Winners must be physically present at the BSides Bangalore & W3-CS Annual Conference 2025 to collect their Award Trophy. An Identification card will be required for verification.</li>

                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                        <div className="tab-pane fade" id="ques3" role="tabpanel" aria-labelledby="ques-tab3">
                                            <div className="ques-details">
                                               
  <h1>💪💻🌍 Wonder Women CTF (W2CTF)</h1>
  <p>
    We're thrilled to launch Wonder Women CTF (W2CTF) as part of BSides Bangalore & the W3-CS Annual Conference 2025!<br/>
    In collaboration with @CyberTalents, W3-CS (World Wide Women in Cyber Security) brings you a 6-hour online CTF competition, exclusively for women.
  </p>

  <h2>📝 Description</h2>
  <p>
    World Wide Women in Cyber Security (W3-CS) is thrilled to join forces with the CyberTalents platform to present the Wonder Women Capture The Flag (W2CTF) during BSides Bangalore & W3-CS Annual Conference 2025 — a dynamic and empowering competition designed to inspire and engage women in the ever-evolving field of cybersecurity.
  </p>
  <p>
    W2CTF is a six-hour, online Capture The Flag (CTF) competition tailored exclusively for women, aiming to ignite curiosity, build skills, and foster greater representation of women in the cybersecurity domain. The CTF has a jeopardy-style format, featuring a diverse range of technical challenges across categories such as Reverse Engineering, Web Security, Digital Forensics, Network Security, and more.
  </p>
  <p>
    No matter your experience level — whether you're just starting out or a seasoned pro — W2CTF has something for everyone! With challenges ranging from beginner-friendly puzzles to advanced exploits, participants will have the opportunity to test their knowledge, sharpen their skills, and connect with a global community of like-minded women in tech.
  </p>

  <h2>🎯 Why Participate?</h2>
  <li>✅ Learn new skills</li>
  <li>✅ Showcase your talent</li>
  <li>✅ Connect with an incredible global community of women in cybersecurity</li>
  <li>🎯 Let’s break barriers and be part of an exciting journey that celebrates women in cybersecurity and pushes the boundaries of what's possible!</li><br/>

  <h2>📅 Mark Your Calendars</h2>
  <li>Date: 22nd June 2025</li>
  <li>Time: 10:00 AM to 4:00 PM IST</li>
  <li>Format: Virtual/Online Competition</li>
  <li>Participation: Individual</li><br/>

  <h2>📝 Registration Steps</h2>
  <li>1. Create an account on CyberTalents: <a href="https://cybertalents.com/register/member" target="_blank">https://cybertalents.com/register/member</a></li>
  <li>2. Go to the CTF webpage for details: <a href="https://cybertalents.com/competitions/wonder-women-capture-the-flag-w2ctf" target="_blank">Wonder Women CTF Page</a></li>
  <li>3. Access to challenges and real-time scoreboard updates will be available once the CTF kicks off.</li><br/>

  <h2>🎁 Prizes</h2>
  <li>🥇 First Place: 15k INR cash prize, Trophy and Winner Certificate</li>
  <li>🥈 Second Place: 7k INR cash prize, Trophy and Winner Certificate</li>
  <li>Top 3 Runner Ups: ₹1500 gift voucher per person, Certificate</li>
  <li>All Participants: Participation certificates</li>
  <li>Note: Winners must be physically present at the BSides Bangalore & W3-CS Annual Conference 2025 to collect their Award Trophy. An Identification card will be required for verification.</li>

                                            </div> {/* <!--ques-details end--> */}
                                        </div>


                                        <div className="tab-pane fade" id="ques4" role="tabpanel" aria-labelledby="ques-tab4">
                                            <div className="ques-details">
                                            <h1>𝗟𝗶𝘃𝗲 𝗛𝗮𝗰𝗸𝗶𝗻𝗴 | 💰 Big Bounties!</h1>
  <p>
    Get ready for the ultimate bug bounty battle!<br/>
    BSides Bangalore & Groww presents an electrifying Live Hacking Event like never before. 💣<br/>
    Up to $7500 per valid bug.
  </p>

  <h2>💸 Bounties (1.5X Special Payout!)</h2>
  <li>🟢 Low: $150 – $400</li>
  <li>🟡 Medium: $400 – $750</li>
  <li>🟠 High: $1000 – $2000</li>
  <li>🔴 Critical: $2500 – $7500</li>
  <li>💥 Total bounty pool? Up to $7,500 per bug!</li><br/>

  <h2>🏆 Awards & Recognition</h2>
  <li>Top 5 hackers + 1 MVP will be crowned live on the BSides stage (11th July 2025)</li>
  <li>🎫 Free non-transferable passes to BSides Bangalore 2025 for the winners</li><br/>

  <h2>📌 Event Details</h2>
  <li>🚀 Limited Seats – Curated Entry Only</li>
  <li>🗓️ Form closes: 3rd July 2025</li>
  <li>🍽️ Lunch & high tea covered</li>
  <li>🚫 Travel/stay not included</li><br/>

  <p>
    Let’s hack out loud. Let’s hack proud.
  </p>
                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                    </div> {/* <!--tab-content end--> */}
                                </div>
                            </div>
                        </div> {/* <!-- faqs-sec-details end--> */}
                    </div>
                </section>
                <AdditionalSection />
                <SponsorSection eventInfo={eventresp} />
                <PartnerSection eventInfo={eventresp} />


                <section className="faqs-sec sec-padding">
                    <div className="container">
                        <div className="sec-title">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">Event FAQS <small>/ find your answers </small></h3>
                            {/*<a href="#" title=""><i className="fa fa-pencil"></i>open a tıcket</a>*/}
                        </div> {/* <!--sec-title end--> */}
                        <div className="faqs-sec-details wow fadeInUp" data-wow-duration="300ms">
                            <div className="row">
                                <div className="col-lg-6">
                                    <ul className="nav nav-tabs wow fadeInUp" data-wow-delay=".2s" id="myTab6" role="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link active" id="ques-tab1" data-toggle="tab" href="#ques1" role="tab" aria-controls="ques1" aria-selected="true"> What is Security BSides and BSides Bangalore? </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="ques-tab2" data-toggle="tab" href="#ques2" role="tab" aria-controls="ques2" aria-selected="false"> Is the conference pass transferable? </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="ques-tab3" data-toggle="tab" href="#ques3" role="tab" aria-controls="ques3" aria-selected="false"> Can I get a refund if I am not able to attend? </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="ques-tab4" data-toggle="tab" href="#ques4" role="tab" aria-controls="ques4" aria-selected="false"> What is the privacy policy of BSides Bangalore? </a>
                                        </li>
                                    </ul> {/* <!--tabs-list end--> */}
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-content" id="myTabContent6">
                                        <div className="tab-pane fade show active" id="ques1" role="tabpanel" aria-labelledby="ques-tab1">
                                            <div className="ques-details">
                                                <p>Security BSides is a community-led framework for establishing events for and by information security community members across the globe. This was launched in the United States in 2009. As of now, there have been 810 BSides events around the world, hosted in 210 cities spanning 60 countries and growing everyday. To find out more about the Security BSides movement visit the <a href="https://bsides.org/w/page/12194156/FrontPage" target="_blank" >Security BSides wiki</a> today.</p>
                                                <p>BSides Bangalore is a non-profit entity approved by BSides. It is driven and supported by cybersecurity community members across the globe. BSides Bangalore presents technical security talks, technical hands-on workshops, CTF, Pannel Discussions, CxO junction and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends.</p>
                                                {/*<ul>
                                                    <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                    <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                    <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                    <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                    <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                    <li><i className="fa fa-check-circle-o"></i> First Awesome Feature</li>
                                                </ul>*/}
                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                        <div className="tab-pane fade" id="ques2" role="tabpanel" aria-labelledby="ques-tab2">
                                            <div className="ques-details">
                                                <p>Conference pass is not transferable. In case of questions, you can write to event organizers through "Contact Us" section in this website. </p>
                                              
                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                        <div className="tab-pane fade" id="ques3" role="tabpanel" aria-labelledby="ques-tab3">
                                            <div className="ques-details">
                                                <p>Registration once done cannot be cancelled. In case of questions, you can write to event organizers through "Contact Us" section in this website.</p>
                                               
                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                        <div className="tab-pane fade" id="ques4" role="tabpanel" aria-labelledby="ques-tab4">
                                            <div className="ques-details">
                                                <p>Privacy policy and other terms and conditions can be found at <a href="https://bsidesbangalore.in/privacypolicy?policy_type=Terms" target="_blank">https://bsidesbangalore.in/privacypolicy?policy_type=Terms</a></p>
                                            </div> {/* <!--ques-details end--> */}
                                        </div>
                                    </div> {/* <!--tab-content end--> */}
                                </div>
                            </div>
                        </div> {/* <!-- faqs-sec-details end--> */}
                    </div>
                </section> {/* <!--faqs-sec end--> */}

                <section className="doc-sec sec-padding">
                    <div className="container">
                        <div className="sec-title">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-ticket fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">About BSides Bangalore <small>/ How to become a member</small></h3>
                        </div> {/* <!--sec-title end--> */}
                        <div className="doc-sec-details">
                            <p>Security BSides is a community-led framework for establishing events for and by information security community members across the globe. BSides Bangalore is a non-profit entity approved by BSides. It is driven and supported by cybersecurity community members across the globe. BSides Bangalore presents technical security talks, technical hands-on workshops, CTF, Pannel Discussions, CxO junction and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends. More details can be found at <a href="https://bsidesbangalore.in" target="_blank">https://bsidesbangalore.in</a></p>
                            <p>You can become a member by visiting <a target="_blank" href="https://bsidesbangalore.in/registermember" >https://bsidesbangalore.in/registermember </a></p>
                        </div> {/* <!-- about-sec-details end--> */}
                    </div>
                </section> {/* <!--about-sec end--> */}

               

                

               <LocationMap eventInfo={eventresp} />
                <Contactus />
                <section className="sec-padding testimonial-sect background-color-white">
                    <div className="container">
                        <div className="sec-title">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-comments-o fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">Testimonials <small> / What People Say About Us</small></h3>
                        </div> {/* <!--sec-title end--> */}
                        <div className="testimonial-sec font-color-black">
                            <div className="comment-slide">
                                <div className="comment-para wow flipInY" data-wow-duration="300ms">
                                    <p>I recently had the incredible opportunity to attend a highly anticipated conference in the field of cybersecurity. It was an enlightening and enriching experience that broadened my knowledge and provided me with valuable insights into the ever-evolving world of cybersecurity. At the conference, I had the privilege of attending a wide range of informative sessions and workshops, where renowned experts shared their expertise on the latest trends, strategies, and technologies in the field. From exploring emerging threats to understanding advanced defensive techniques, every session was packed with valuable information that I can directly apply to my work. But that's not all! The conference surprised me with an exciting hands-on session on secret lock picking. Led by skilled professionals, the session offered a unique opportunity to explore the fascinating world of physical security and understand the vulnerabilities that lie beyond digital defenses. It was a thrilling experience that further broadened my perspective on cybersecurity. I look forward to sharing my learnings with my colleagues at Jio and collaborating with them to strengthen our organization's security posture. Together, we can mitigate risks, protect sensitive information, and ensure a secure digital environment. Huge thanks to the organisers, volunteers and presenters of #bsidesbangalore and Sponsors for awesome swags.</p>
                                    <div className="commenter-name">
                                        <span>by  Participant </span>
        </div>
                                </div>
                               {/* <div className="cmntr-img wow flipInY" data-wow-duration="300ms">
                                    <div className="hex-deg">
                                        <div className="hex-deg">
                                            <div className="hex-deg">
                                                <div className="hex-inner">
                                                    <img src="/images/resources/t-img1.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    </div>*/}
                            </div> {/* <!--comment-slide end--> */}
                            <div className="comment-slide">
                                <div className="comment-para wow flipInY" data-wow-duration="300ms">
                                    <p>It was an incredible experience being part of the first-ever edition of BSides Bangalore. I was honored to be part of the Award Jury Panel in partnership with eminent industry leaders. Members of the Organizing Committee and all the volunteers have worked tirelessly over the past several weeks for making this 4 Conference a great success, which was evident from the overwhelming attendance, crazy energy, and community vibe. I am humbled by all your hard work and passion for growing the community. It was a difficult job to choose the winners from the list of all the great nominations across various categories. I deeply appreciate the founders for keeping the entire process absolutely transparent and unbiased with the sole purpose of recognizing and encouraging the contributions towards the larger security community. Congratulations to all the deserving winners and best wishes to all nominees to continue supporting the wider security community and amplify the mutual growth. Members of the Organizing Committee and all the volunteers have worked tirelessly over the past several weeks for making this Conference a great success, which was evident from the overwhelming attendance, crazy energy, and community vibe. I am humbled by all your hard work and greatly appreciate all your efforts.</p>
                                    <div className="commenter-name">
                                        <span>by  Participant </span>
        </div>
                                </div>
                               {/* <div className="cmntr-img wow flipInY" data-wow-duration="300ms">
                                    <div className="hex-deg">
                                        <div className="hex-deg">
                                            <div className="hex-deg">
                                                <div className="hex-inner">
                                                    <img src="/images/resources/t-img2.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    </div>*/}
                            </div> {/* <!--comment-slide end--> */}
                            <div className="comment-slide">
                                <div className="comment-para wow flipInY" data-wow-duration="300ms">
                                    <p>It was truly an enriching experience attending BSides Bangalore Cybersecurity Conference. The conference was power-packed with various Keynote Addresses, Interactive Cybersecurity Technical Sessions, Engaging Panel Discussions, Hands-on Workshops, Lockpicking & Hardware Villages, ToolsForge, CTFs, CXO Round-table, Awards Ceremony, Sponsor Booths, Goodies & Swags, etc It was an amazing opportunity to witness some of the sharpest & most innovative minds which included several Information Security executives, leaders, experts, evangelists, enthusiasts, researchers, professionals & students. A huge thank you to the entire Team BSides Bangalore - all the organizers & volunteers for their tremendous hardwork & enormous efforts to make this a grand success. All in all, an event that will be cherished for long!</p>
                                    <div className="commenter-name">
                                        <span>by  Participant </span>
        </div>
                                </div>
                                {/*<div className="cmntr-img wow flipInY" data-wow-duration="300ms">
                                    <div className="hex-deg">
                                        <div className="hex-deg">
                                            <div className="hex-deg">
                                                <div className="hex-inner">
                                                    <img src="/images/resources/t-img3.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    </div>*/}
                            </div> {/* <!--comment-slide end--> */}
                        </div> {/* <!--testimonial-sec end--> */}
                    </div>
                </section> {/* <!--sec-padding end--> */}
                 </>}
                <MainWebFooter  /> 

                
                <ScrollToTop  component={<i className="fa fa-angle-up"></i>} smooth />
                <ToastContainer position="bottom-right"/>
                </div>}
            </>
        );
    }
}
export default EvtHome;
